/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JustificationSource } from './JustificationSource';
import {
    JustificationSourceFromJSON,
    JustificationSourceFromJSONTyped,
    JustificationSourceToJSON,
    JustificationSourceToJSONTyped,
} from './JustificationSource';

/**
 * 
 * @export
 * @interface UpdateSupplementJustificationsRequestJustificationsInner
 */
export interface UpdateSupplementJustificationsRequestJustificationsInner {
    /**
     * ID of the justification to update
     * @type {number}
     * @memberof UpdateSupplementJustificationsRequestJustificationsInner
     */
    justificationId: number;
    /**
     * New justification text (null or empty string to clear)
     * @type {string}
     * @memberof UpdateSupplementJustificationsRequestJustificationsInner
     */
    justificationText?: string | null;
    /**
     * 
     * @type {JustificationSource}
     * @memberof UpdateSupplementJustificationsRequestJustificationsInner
     */
    justificationSource?: JustificationSource;
}



/**
 * Check if a given object implements the UpdateSupplementJustificationsRequestJustificationsInner interface.
 */
export function instanceOfUpdateSupplementJustificationsRequestJustificationsInner(value: object): value is UpdateSupplementJustificationsRequestJustificationsInner {
    if (!('justificationId' in value) || value['justificationId'] === undefined) return false;
    return true;
}

export function UpdateSupplementJustificationsRequestJustificationsInnerFromJSON(json: any): UpdateSupplementJustificationsRequestJustificationsInner {
    return UpdateSupplementJustificationsRequestJustificationsInnerFromJSONTyped(json, false);
}

export function UpdateSupplementJustificationsRequestJustificationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplementJustificationsRequestJustificationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'justificationId': json['justificationId'],
        'justificationText': json['justificationText'] == null ? undefined : json['justificationText'],
        'justificationSource': json['justificationSource'] == null ? undefined : JustificationSourceFromJSON(json['justificationSource']),
    };
}

export function UpdateSupplementJustificationsRequestJustificationsInnerToJSON(json: any): UpdateSupplementJustificationsRequestJustificationsInner {
    return UpdateSupplementJustificationsRequestJustificationsInnerToJSONTyped(json, false);
}

export function UpdateSupplementJustificationsRequestJustificationsInnerToJSONTyped(value?: UpdateSupplementJustificationsRequestJustificationsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'justificationId': value['justificationId'],
        'justificationText': value['justificationText'],
        'justificationSource': JustificationSourceToJSON(value['justificationSource']),
    };
}

